module.exports =
  error_messages:
    after: (field, [target]) => "O campo #{field} deve estar depois do campo #{target}"
    alpha_dash: (field) => "O campo #{field} deve conter letras, números e traços"
    alpha_num: (field) => "O campo #{field} deve conter somente letras e números"
    alpha_spaces: (field) => "The #{field} só pode conter caracteres alfabéticos e espaços"
    alpha: (field) => "O campo #{field} deve conter somente letras"
    before: (field, [target]) => "O campo #{field} deve estar antes do campo #{target}"
    between: (field, [min, max]) => "O campo #{field} deve estar entre #{min} e #{max}"
    confirmed: (field, [confirmedField]) => "O campo #{field} e #{confirmedField} devem ser iguais"
    credit_card: (field) => "O campo #{field} é inválido"
    date_between: (field, [min, max]) => "O campo #{field} deve estar entre #{min} e #{max}"
    date_format: (field, [format]) => "O campo #{field} deve estar no formato #{format}"
    decimal: (field, [decimals] = ['*']) => "O campo #{field} deve ser numérico e deve conter #{decimals == '*' ? '' : decimals} casas decimais"
    digits: (field, [length]) => "O campo #{field} deve ser numérico e ter #{length} dígitos"
    dimensions: (field, [width, height]) => "O campo #{field} deve ter #{width} pixels de largura por #{height} pixels de altura"
    email: (field) => "O campo #{field} deve ser um email válido"
    ext: (field) => "O campo #{field} deve ser um arquivo válido"
    image: (field) => "O campo #{field} deve ser uma imagem"
    in: (field) => "O campo #{field} deve ter um valor válido"
    ip: (field) => "O campo #{field} deve ser um endereço IP válido"
    max: (field, [length]) => "O campo #{field} não deve ter mais que #{length} caracteres"
    max_value: (field, [max]) => "O campo #{field} precisa ser #{max} ou menor"
    mimes: (field) => "O campo #{field} deve ser um tipo de arquivo válido"
    min: (field, [length]) => "O campo #{field} deve conter pelo menos #{length} caracteres"
    min_value: (field, [min]) => "O campo #{field} precisa ser #{min} ou maior"
    not_in: (field) => "O campo #{field} deve ser um valor válido"
    numeric: (field) => "O campo #{field} deve conter apenas números"
    regex: (field) => "O campo #{field} possui um formato inválido"
    required: (field) => "O campo #{field} é obrigatório"
    size: (field, [size]) => "O campo #{field} deve ser menor que #{size} KB"
    url: (field) => "O campo #{field} não é uma URL válida"

  attributes:
    name: "nome"
    email: "email"
    password: "senha"
    password_confirmation: "repetir senha"
    current_password: "senha atual"
    reset_password_token: "token"
    subject: "assunto"
    body: "conteúdo"
    template_category_id: "categoria"
    company_id: "empresa"
    first_name: "nome"
    last_name: "sobrenome"
    business: "empresa"
    business_name: "nome da empresa"
    position: "cargo"
    telephone: "telefone"
    cellphone: "celular"
    address: "endereço"
    domain: "domínio"
    city: "cidade"
    state: "estado"
    country: "país"
    contact_group: "grupo"
    role: "função"
    timezone: "fuso horário"
    pipedrive_api_key: "API KEY do Pipedrive"
    nectar_api_key: "API KEY do NectarCRM"
    'crm_setting.bcc_reply_email': "email de resposta"
    'crm_setting.bcc_send_email': "email de envio"
    'webhook_setting.url': "URL"
    access_key: "chave de acesso"
    replace_user_id: "usuário"
    task_service: "tipo de tarefa"
    due_on_time: "horário"
    email_domain: "domínio do email"
    send_at: 'horário da ação'
    emails_per_day: 'ativação diária'
    weekdays_to_send: 'dias válidos para envio'
    delay_before_finishing_contact_amount: 'intervalo para finalizar contato no fluxo'
    field: 'Nome'
    webhook_url: 'URL do webhook'
    url: 'URL'
    caller_id: 'Numero'
    meeting_type_id: 'Tipo de Reunião'
    kind: 'Tipo de propriedade'

  voip:
    call_status:
      idle: 'Ocioso'
      calling: 'Chamando'
      connected: 'Em ligação'
      ended: 'Ligação encerrada'
      failed: 'Ligação encerrada'

    error_messages:
      generic: 'Ocorreu um erro com o seu serviço de VoiP. Tente mais tarde ou entre em contato com o suporte'
      unauthorized_manager: 'Acesso ao VoiP não autorizado. Para mais informações entre em contato com o time de CS do Reev'
      unauthorized: 'Acesso ao VoiP não autorizado. Para mais informações entre em contato com gerente da conta'
      web_rtc_support: 'Esse navegador não tem suporte para a realização de chamadas VoiP'
      authentication: 'Ocorreu um erro de autenticação no serviço de VoiP. Tente mais tarde ou entre em contato com o suporte'
      mic_permission: 'O microfone está bloqueado para uso do navegador. Habilite para realizar chamadas'
      ongoing_call: 'Já existe uma chamada em andamento.'
      failed_status:
        'User Denied Media Access': 'Microfone não habilitado'
        'Canceled': 'Cancelada'
        'Unavailable': 'Serviço indisponível'
        'Not Found': 'Número inexistente'
        'Busy': 'Número ocupado ou inexistente'
        'Unavailable': 'Não atendida'

  recipient:
    soft_bounce:
      generic: ->
        "O servidor de e-mail do contato rejeitou seu e-mail neste momento. O envio foi reagendado para o dia seguinte."
      message_rejected: (attempts, max_attempts) ->
        "O servidor de e-mail do contato rejeitou seu e-mail neste momento. O envio foi reagendado para o dia seguinte. #{attempts}/#{max_attempts} tentativas"
      account_failure: (attempts, max_attempts) ->
        "O e-mail não foi enviado pois sua conta não estava sincronizada no momento do envio. O envio do e-mail foi reagendado para o dia seguinte. #{attempts}/#{max_attempts} tentativas"
      limit_exceeded: (attempts, max_attempts) ->
        "O e-mail não foi enviado pois você excedeu o limite de envio para o dia. O envio do e-mail foi reagendado para o dia seguinte. #{attempts}/#{max_attempts} tentativas"
      service_failure: (attempts, max_attempts) ->
        "O e-mail não foi enviado pois ocorreu um problema com o servidor de envio. O envio do e-mail foi reagendado para o dia seguinte. #{attempts}/#{max_attempts} tentativas"
      unknown: (attempts, max_attempts) ->
        "O e-mail não foi enviado pois ocorreu um problema no momento do envio. O envio do e-mail foi reagendado para o dia seguinte. #{attempts}/#{max_attempts} tentativas"



// WEBPACK FOOTER //
// ./src/locales/pt_BR.coffee